<template lang="html">
  <div class="title">
    <div class="left" v-if="isDashboard"><span class="time">{{time}}</span><span class="weekdays">{{weekdays}}</span></div>
    <div class="left back" v-else @click="back">返回</div>
    <h1  @click="back">{{name}}</h1>
    <!-- <div class="right" v-if="isDashboard">技术支持：海南现代设施农业研究院有限公司</div> -->
        <div class="right" v-if="isDashboard">技术支持：甲骨文科技股份</div>
    <div class="right" v-else></div>
  </div>
</template>

<script>
import moment, { weekdays } from 'moment';
import 'moment/locale/zh-cn';
const daysArr = ['日', '一', '二', '三', '四', '五', '六'];
export default {
  props: {
    name: String,
    isDashboard: {
      type: Boolean,
      default: false
    },
    onBack: false
  },
  created() {
  },
  methods: {
    back() {
      // console.log(this.timerDashboard)
      // if (this.onBack) {
      //   this.$emit('backClick');
      // } else {
      //   this.$router.push('/rundadashboard');
      // }
    }
  },
  data() {
    return {
      color: this.$store.state.color,
      // time: moment().format('LLLL')
      time: `${moment().format('YYYY.MM.DD')} `,
      weekdays: `星期${daysArr[moment().day()]}`
    }
  }
}

</script>


<style lang="less" scoped>
@import '../../../assets/font/font.css';

.title {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 15vh;
  height: 15vh;
  background: url('../../../assets/img/common/topBg.png');
  background-size: 100% 100%;
  color: white;

  h1 {
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    font-size: 5.2vh;
    font-weight: bold;
    text-align: center;
    line-height: 9.5vh;
    font-weight: bold;
    letter-spacing: 10px;
  }

  .left,
  .right {
    // margin-top: 68px;
    margin-top: 7.2vh;
    width: 50%;
    height: 55px;
    line-height: 55px;
    font-family: 'digital';
  }

  .left {
    padding-left: 36px;
    text-align: left;
    font-size: 22px;
    font-weight: 400;
    .weekdays {
      font-size: 20px;
      font-weight: 400;
    }
    .title {
      height: 18px;
      font-size: 22px;
      font-weight: 400;
    }
  }

  .right {
    padding-right: 24px;
    text-align: right;
    font-size: 18px;
    font-weight: 400;

    .brand {
      margin-right: 30px;
      font-size: 20px;
      font-weight: 400;
    }
  }

  .back {
    position: relative;
    padding-left: 55px;
    cursor: pointer;

    &:before {
      content: '';
      position: absolute;
      top: 13px;
      left: 22px;
      width: 26px;
      height: 24px;
      margin-right: 10px;
      background: url('../../../../static/img/common/back.png');
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?0147a679